import cn from 'classnames'
import Link from 'next/link'
// import logo from 'next-seo/lib/jsonld/logo'
import React, { PropsWithChildren } from 'react'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { SHOW_COLLECTIONS_FOR_ALL } from 'src/config/config'

import DefaultIcon from '../../assets/defaulticon-32x32.png'
import { Avatar } from '../global/Avatar/Avatar'
export interface CollectionCardProps {
  title: string | null | undefined
  url: string
  description: string | null | undefined
  icon?: any
}

export const CollectionCard: React.FC<PropsWithChildren<CollectionCardProps>> = ({ title, url, description, icon }) => {
  return (
    <Link
      href={url}
      passHref
      className={cn(
        'flex flex-col',
        `${SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'insight-cards py-[20px] px-[24px] min-h-[201px] rounded-lg border-navybright border-l-[7px]' : 'h-[15rem] w-full bg-white rounded-md px-8 py-6'}`,
      )}
    >
      <div
        className={cn(
          'flex flex-col ',
          SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'mb-[16px] mr-[28px] ' : ' h-[10rem] mb-[0.3rem]',
        )}
      >
        {SHOW_COLLECTIONS_FOR_ALL == 'true' ? (
          <div className="flex gap-[8px] h-[27px] items-center">
            <Avatar
              size="20px"
              initialsTextSize="12px"
              url={icon?.url || DefaultIcon || ''}
              name={''}
              defaultMode="initials"
              variant="transparent"
              className={''}
              border={'no-border-no-radius'}
            />
            <p
              className={`font-bold text-[18px]  overflow-hidden ${SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'leading-[27px] mt-0 font-secondary line-clamp-1 text-[#333333]' : 'leading-[27px] mt-1 text-textdark'}`}
            >
              {title}
            </p>
          </div>
        ) : (
          <p className="text-textdark font-bold text-[1.4rem] mt-1 h-[3.1rem] overflow-hidden leading-6">{title}</p>
        )}
        <div className={cn('overflow-hidden ', SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'mt-[7px]' : 'mt-[.7rem]')}>
          <HtmlContentViewer
            html={description || ''}
            contentClassName={`header-des-html text-[16px] font-primary ${SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'line-clamp-3 text-[#767676] leading-[22px] font-normal' : 'truncate'} `}
          />
        </div>
      </div>
      <div className="flex justify-start mt-auto">
        <p
          className={`text-textdark font-bold ${SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'font-secondary text-[14px] leading-[22px] flex bg-[#29EF97] justify-center p-[0.5rem] rounded-[30px] w-[230px] h-[40px]' : 'font-primary text-[15px] leading-[18px] mr-[0.5rem] ml-[5px] underline'}`}
        >
          {SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'Explore Collection' : 'Explore ' + title}
        </p>
      </div>
    </Link>
  )
}
